import { cloneDeep } from "lodash";
import React, { useEffect, useState } from "react";
import { Loader } from "../../components/loader";
import ConvertStringToHtml from "../../components/ConvertStringToHtml";
import { CheckBox } from "../../components/reactHookFormFields/checkbox";

const SectionNotesContent = ({
  isLoadingNotes,
  control,
  selectedEncounterSections,
  setSelectedEncounterSections,
  setValue,
}) => {
  const [sectionsLoaded, setSectionsLoaded] = useState(false);
  const handleList = (e, note, slug, name, type) => {
    if (
      (slug == "assessment" ||
        slug == "plan" ||
        slug == "assessment_and_plan") &&
      type === "prb"
    ) {
      let temp = note?.note_health_conditions?.map((prb) => {
        if (prb?.code == name?.code) {
          prb.selected = e?.target?.checked;
        }
        return prb;
      });
      setSelectedEncounterSections(
        selectedEncounterSections.map(function (a) {
          if (a?.slug === note?.slug) {
            a.selected =
              a?.note_health_conditions?.length ===
              temp?.filter((prb) => prb?.selected).length;
            setValue(a?.slug, a.selected);
            a.note_health_conditions = temp;
          }
          return a;
        })
      );
    } else {
      let tempSelectedEncounterSections = cloneDeep(selectedEncounterSections);
      setSelectedEncounterSections(
        tempSelectedEncounterSections.map(function (a) {
          if (a?.slug === note?.slug) {
            a.selected = e?.target?.checked;
            if (
              a.slug == "assessment" ||
              a.slug == "plan" ||
              a.slug == "assessment_and_plan"
            ) {
              a?.note_health_conditions?.map((prb) => {
                setValue(
                  `${a?.slug}_${prb?.code}`,
                  e?.target?.checked
                );
                prb.selected = e?.target?.checked;
                return prb;
              });
            }
          }
          return a;
        })
      );
    }
  };

  useEffect(() => {
    if (!sectionsLoaded) {
      selectedEncounterSections.forEach(function (a) {
        setValue(a?.slug, false);
      });
      setValue("select_all", false);
      setTimeout(() => {
        setSectionsLoaded(true);
      }, 1000);
    }
  }, [selectedEncounterSections]);

  useEffect(() => {
    return () => {
      setSectionsLoaded(false);
    }
  }, []);

  const handleSelectAll = (e) => {
    setSelectedEncounterSections(
      selectedEncounterSections.map(function (a) {
        if (a?.note_text?.trim() !== "" || a?.note_text?.trim() !== "") {
          a.selected = e?.target?.checked;
          setValue(a?.slug, a.selected);
        }
        if (a?.slug == "assessment" || a?.slug == "plan" || a?.slug == "assessment_and_plan") {
          a.note_health_conditions = cloneDeep(a?.note_health_conditions)?.map((prb) => {
            prb.selected = e?.target?.checked;
            setValue(`${a?.slug}_${prb?.code}`, prb.selected);
            return prb;
          });
        }
        return a;
      })
    );
  };

  const replaceAsterisk = (noteTxt='') => {
    return noteTxt.replace(/\*(.*?)\*/g, "<b>$1</b>").replace(/\n/g,'<br/>');
  }

  return (
    <>
      {isLoadingNotes ? (
        <Loader />
      ) : (
        <>
          <CheckBox
            control={control}
            name={"select_all"}
            onChange={(e) => handleSelectAll(e)}
            defaultValue={false}
            title="Select All"
          />
          <div style={{ overflow: "auto", height: "calc(100vh - 16rem)" }}>
            {selectedEncounterSections?.map((note) => {
              return (
                <div
                  style={{
                    padding: "15px",
                    border: "1px solid #cecece",
                    borderRadius: "5px",
                    margin: "10px 0px",
                    cursor:
                      note?.note_health_conditions?.length > 0
                        ? false
                        : note?.note_text?.trim() === "" && "not-allowed",
                  }}
                  disabled={note?.note_text?.trim() === ""}
                >
                  <div className="flex flex-col">
                    <CheckBox
                      control={control}
                      name={note?.slug}
                      disabled={
                        note?.note_health_conditions?.length > 0
                          ? false
                          : note?.note_text?.trim() === ""
                      }
                      onChange={(e) => handleList(e, note)}
                      defaultValue={false}
                      title={note?.title}
                    />
                    {!note?.skip_note_text && <div className="px-4">
                      <ConvertStringToHtml msg={replaceAsterisk(note?.note_text)} />
                    </div>}
                    {(note.slug == "assessment" ||
                      note.slug == "plan" ||
                      note.slug == "assessment_and_plan") &&
                      note?.note_health_conditions &&
                      note?.note_health_conditions?.length > 0 && (
                        <div className="pl-5">
                          {note?.note_health_conditions?.map((prb) => {
                            return (
                              <div className="border rounded-sm p-2 mt-1">
                              <CheckBox
                                control={control}
                                name={`${note.slug}_${prb?.code}`}
                                onChange={(e) =>
                                  handleList(
                                    e,
                                    note,
                                    note.slug,
                                    prb,
                                    "prb"
                                  )
                                }
                                defaultValue={prb?.selected}
                                title={`${prb?.code + ' - ' + prb?.title}`}
                              />
                              {prb?.assessment && <p className="text-sm text-gray-600">
                                <strong>Assessment:</strong> <ConvertStringToHtml msg={replaceAsterisk(prb?.assessment)} />
                              </p>}
                              {prb?.plan && <p className="text-sm text-gray-600">
                                <strong>Plan:</strong> <ConvertStringToHtml msg={replaceAsterisk(prb?.plan)} />
                              </p>}
                              </div>
                            );
                          })}
                        </div>
                      )}
                  </div>
                </div>
              );
            })}
          </div>
        </>
      )}
    </>
  );
};

export default SectionNotesContent;
